"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWhatsAppLinkWithText = void 0;
function getWhatsAppLinkWithText(text) {
    const WHATSAPP_LINK = "https://wa.me/9720587100571";
    return `${WHATSAPP_LINK}?text=${text}`;
}
exports.getWhatsAppLinkWithText = getWhatsAppLinkWithText;
